import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetSampleTypeById,
	adminGetAllSampleTypes,
	resetFocusSampleType,
	initNewSampleType,
	adminPatchSampleType,
	adminPostSampleType,
	adminDeleteSampleType,
} from 'services/sampleType';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/SampleTypes/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	name: Yup.string().required('Champ requis'),
	code: Yup.string().required('Champ requis'),
	price: Yup.number()
		.positive('Le prix doit être supérieur à 0')
		.test('isValidPrice', 'Prix non valide', (value) => {
			if (!value) return false;
			return /^\d{1,8}(?:\.\d{1,2})?$/.test(value.toString());
		})
		.required('Champ requis'),
});

class SampleTypesAdmin extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusSampleType();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllSampleTypes();
	};

	focusOnElement = (elt) => {
		this.props.adminGetSampleTypeById(elt.id);
	};

	onAddClick = () => {
		this.props.initNewSampleType();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostSampleType(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchSampleType(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteSampleType(this.props.sampleTypes.focus.data.id);
	};

	render() {
		const { sampleTypes } = this.props;
		const { focus, list } = sampleTypes;
		const sampleType = focus.data;
		const newSampleType = sampleType !== null && sampleType.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={sampleTypes.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity='Type de prélèvement'
					addButtonText='Nouveau Type de prélèvement'
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.name}
					groupField={false}
					focusedEltId={sampleType}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity='Type de prélèvement'
					icon='info'
				>
					{sampleType !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: sampleType.id,
								name: sampleType.name || '',
								code: sampleType.code || '',
								price: sampleType.price || 0.0,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusSampleType}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newSampleType ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newSampleType && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		sampleTypes: state.admin.sampleTypes,
	};
};

const mapDispatchToProps = {
	adminGetAllSampleTypes,
	adminGetSampleTypeById,
	adminPatchSampleType,
	adminDeleteSampleType,
	resetFocusSampleType,
	adminPostSampleType,
	initNewSampleType,
};

export default connect(mapStateToProps, mapDispatchToProps)(SampleTypesAdmin);
